import { MODEL_EXPERIMENT_FLAG } from "../../shared/featureFlagNames";
import { assignedExperimentModel } from "../../shared/modelExperiment";
import { config } from "../environment";
import { useFeatureFlag } from "./useFeatureFlag";

export function useModelExperiment(
  threadKey: string | null | undefined
): string | null {
  const enabled = useFeatureFlag(MODEL_EXPERIMENT_FLAG);
  if (!enabled || !threadKey) return null;
  return assignedExperimentModel(threadKey, config.managedChatModels);
}
